import React from 'react'
import DataGrid from '../../../../table/DataGrid'
import TextValue from '../../../../text/TextValue'
import { Box, Table, TableContainer, TableBody, TableRow, TableCell, Chip, Typography } from '@mui/material'
import groupBy from 'lodash/groupBy'
import isEmpty from 'lodash/isEmpty'
import pluralize from 'pluralize'

const TableCompareImport = ({ module = '', type = '', status, description, data = [] }) => {
  const messages = groupBy(data, 'message')
  const colorStatus = (status) => {
    switch (status) {
      case 'success':
        return 'success';
      case 'failed':
        return 'error';
      case 'executing':
        return 'info';
      default:
        return 'warning';
    }
  }
  return (
    <Box className='flex flex-col gap-4 pt-4'>
      { type &&
        <TextValue title='Type' classNameValue='capitalize' value={type} />
      }
      { status &&
        <TextValue title='Status' classNameValue='flex-col' value={
          <>
          <Chip size='small' label={status} className='uppercase' color={colorStatus(status)} />
          {description && <Typography variant='caption' className='opacity-50'>{description}</Typography>}
          </>
        } />
      }
      { !isEmpty(messages) &&
        <TableContainer>
          <Table>
            <TableBody>
            { Object.keys(messages).map((key, index) => (
              <TableRow key={`${type}-${index}`}>
                <TableCell width={300}>
                  {key}
                </TableCell>
                <TableCell align='right'>
                  {messages[key]?.length} {pluralize(module)}
                </TableCell>
              </TableRow>
            ))}
            </TableBody>
          </Table>
        </TableContainer>
      }
      {data?.length > 0 &&
      <div className='h-screen-1/3 relative'>
        <DataGrid 
          id='table-compare-import'
          showSetting={false}
          rows={data.sort((a, b) => b.code - a.code).map((row, index) => ({
            ...row,
            index: index + 1,
            user: <div className='max-w-160px'>
              <p>{row.code}</p>
              <p className='text-muted-foreground text-sm opacity-60 text-ellipsis'>{row.email}</p>
            </div>,
            _id: row._id ? row._id : index
          }))}
          rowsPerPage={data?.length || 0}
          columns={[
            { label: '#', key: 'index', align: 'center', show: true, hide: false },
            { label: 'user', key: 'user', width: '160px', show: true, hide: false },
            { label: 'message', key: 'message', show: true, hide: false }
          ]}
          labelNoRows="You don't have any changes yet"
        />
      </div>
      }
    </Box>
  )
}
export default TableCompareImport